// @flow

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import shallowCompare from 'react-addons-shallow-compare';

import Link from './Link';
import classNames from 'classnames';

class Ariane extends Component {

  static propTypes = {
    icon: PropTypes.string.isRequired,

    /**
     * Array of {
        name: 'Commande',
        link: null or Route (ex: RoutingEnum.ORDER_LIST). It also handle an empty string
        params: object,
        query: object
      }
     */
    details: PropTypes.array.isRequired
  };

  shouldComponentUpdate(nextProps: Object, nextState: Object) {
    return shallowCompare(this, nextProps, nextState);
  }

  render() {
    let arianeNames = [];

    const details = this.props.details;

    for (let i = 0; i < details.length; i++) {
      const name = details[i].name;
      const link = details[i].link;
      const params = details[i].params;
      const query = details[i].query;

      // -- Setup name class
      const className = classNames('ariane__name', `ariane_level__${i}`);

      // -- Setup link if exists. We just put the name otherwise.
      let nameView = (
        <span className={className}>
          {name}
        </span>
      );

      if (!_.isNull(link) && !_.isEmpty(link)) { // handle null or empty string link.
        nameView = (
          <Link to={link} params={params} className={className} query={query}>
            {name}
          </Link>
        );
      }

      arianeNames.push(
        <span key={i}>
          {nameView}
          {i !== details.length - 1 &&
            <span className="ariane_separator">></span>
          }
        </span>
      );
    }

    return (
      <div id="ariane">
        <i className={`fa ${this.props.icon}`} />
        {arianeNames}
      </div>
    );
  }

}

export default Ariane;



// WEBPACK FOOTER //
// ./sdk/scripts/components/Ariane.js